import React from "react";

const NotFound: React.FunctionComponent<any> = () => {
  return <h3>Page Not Found</h3>;
};

export default NotFound;
